export default __webpack_public_path__ + "static/media/lifebar4.5a614507.PNG";